
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping",
      function () {
        return require("private-next-pages/shipping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping"])
      });
    }
  